import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { BookOpenCheckIcon, HeartHandshakeIcon, HandshakeIcon } from 'lucide-react';
const steps = [{
  icon: BookOpenCheckIcon,
  number: '01',
  title: 'Elegí la herramienta para hoy',
  description: 'Ubicá el capítulo que responde al momento que están atravesando: una discusión, distancia o cansancio.'
}, {
  icon: HeartHandshakeIcon,
  number: '02',
  title: 'Aplíquenla esa misma noche',
  description: 'SeguÍ ejercicios simples y concretos, pensados para bajar la tensión sin sumar otra carga a la rutina.'
}, {
  icon: HandshakeIcon,
  number: '03',
  title: 'Cierren con acuerdos que sostienen',
  description: 'Transformen esa conversación en un acuerdo claro para que el cambio no se pierda al día siguiente.'
}];
export function HowItWorksSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full bg-[#0D002B] py-24 md:py-32" data-id="element-285" data-mp="wbfvi5d2fjvr">
      <div className="mx-auto max-w-6xl px-6" data-id="element-286" data-mp="119hb2gba912h">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 24
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} className="mx-auto mb-14 max-w-2xl text-center" data-id="element-287" data-mp="11867aghu7tbd">
          <p className="mb-4 text-sm font-bold uppercase tracking-[0.18em] text-[#E5A83B]" data-id="element-288" data-mp="mk1ntaayndrj">
            Sin teoría de más
          </p>
          <h2 className="font-serif text-3xl font-bold leading-tight text-white md:text-4xl lg:text-5xl" data-id="element-289" data-mp="rdeahew2xahn">
            Cómo lo aplicás{' '}
            <span className="text-[#E5A83B]" data-id="element-290" data-mp="3uzv3xo1dqn82">sin complicarte</span>
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-[#C4B5FD]" data-id="element-291" data-mp="125wlccp9g6y2">
            Un plan claro para volver a actuar como equipo, incluso cuando hoy
            no saben por dónde empezar.
          </p>
        </motion.div>

        <div className="grid gap-5 md:grid-cols-3 md:gap-6" data-id="element-292" data-mp="1ayq5anfnjui9">
          {steps.map((step, index) => {
          const Icon = step.icon;
          return <motion.article key={step.number} initial={{
            opacity: 0,
            y: 24
          }} animate={isInView ? {
            opacity: 1,
            y: 0
          } : {
            opacity: 0,
            y: 24
          }} transition={{
            duration: 0.5,
            delay: index * 0.12,
            ease: 'easeOut'
          }} className="relative rounded-2xl border border-[#7C3AED]/35 bg-[#110038] p-7 md:p-8" data-id="element-293" data-mp="j7aiote3i7s1" data-mpi={index}>
                <span className="absolute right-6 top-6 font-serif text-4xl font-bold text-[#7C3AED]/30" data-id="element-294" data-mp="2b7prmme20p1u">
                  {step.number}
                </span>
                <div className="mb-6 flex h-12 w-12 items-center justify-center rounded-xl bg-[#7C3AED]/20" data-id="element-295" data-mp="225ynvn32qsam">
                  <Icon className="h-6 w-6 text-[#E5A83B]" aria-hidden="true" data-id="element-296" data-mp="2pvt0q4ne8guv" />
                </div>
                <h3 className="pr-10 font-serif text-xl font-bold text-white" data-id="element-297" data-mp="2uudzs0qwsuhq">
                  {step.title}
                </h3>
                <p className="mt-3 font-sans leading-relaxed text-[#C4B5FD]" data-id="element-298" data-mp="2g4pvcqnflfps">
                  {step.description}
                </p>
              </motion.article>;
        })}
        </div>
      </div>
    </section>;
}